import React            from 'react';
import { useNavigate }  from 'react-router-dom';
import PropTypes        from 'prop-types';

import ActorProfileHeaderRating from '../../ActorRating/ActorProfileHeaderRating';

import Translations    from '../../../utils/Translations';
import { generateKey } from '../../../utils/CommonUtils';

const ActorProfileNavigation = (props) => {

    const { actorId, routes, navigationRef, lastActiveRouteIndex, scrollToBreadcrumbs } = props;
    const navigate = useNavigate();

    const navItems = Object.values(routes ?? {}).map((route, index) => {
        const specialClass = route.isActive 
            ? `is-active ${(lastActiveRouteIndex > route.index)
                    ? 'swing-to-the-left' : lastActiveRouteIndex === route.index ? '' 
                    : 'swing-to-the-right'
            }` : '';
        const onNavItemClick = (e) => {
            e.preventDefault();
            navigate(route.path);
            scrollToBreadcrumbs();
        };
        return (
            <li key={generateKey(route.key, index)} className="navigation__item">
                <div 
                    className   = {`js-pjax-link navigation__link ${specialClass} `}
                    onClick     = {onNavItemClick}
                >
                    {route.label}
                    {route.count ? <span className='badge--number'>{route.count}</span> : null}
                    {route.isNew ? <span className='badge--highlight -margin-xs'>{Translations.get('navigation.navbar-badge_new')}</span> : null}
                </div>
            </li>
        );  
    });

    return (
        <div ref={navigationRef} className={`actor-profile-header-navigation ${props.isModelOnline ? "-mq-border-top" : ""}`}>
            <nav className="navigation--inpage -auto-height">
                <ul className="navigation__list--inpage -flexible-menu">
                    {navItems}
                </ul>
            </nav>

            <ActorProfileHeaderRating actorId={actorId}/>
            
        </div>
    );
};

ActorProfileNavigation.propTypes = {
    actorId:              PropTypes.number.isRequired,
    isModelOnline:        PropTypes.bool.isRequired,
    lastActiveRouteIndex: PropTypes.number,
    navigationRef:        PropTypes.object.isRequired,
    routes:               PropTypes.object.isRequired,
    scrollToBreadcrumbs:  PropTypes.func.isRequired,
};

export default ActorProfileNavigation;
